// Shared money formatting utility
// Delegates to the tenant-aware formatCurrencyAmount so that the active
// tenant's currency drives display when no per-record currency is supplied.

import { formatCurrencyAmount, getTenant } from '../../theme/tokens'
const normalizeCurrency = (currency?: string): string | undefined => {
  if (!currency) return undefined
  const c = currency.toUpperCase()
  if (c === 'RS.' || c === 'RS' || c === 'LKR' || c === 'USD' || c === 'THB')
    return getTenant().currency.code
  return c
}
export function formatMoney(amount: number, currency?: string): string {
  const iso = normalizeCurrency(currency)
  return formatCurrencyAmount(Number.isFinite(amount) ? amount : 0, {
    currency: iso,
  })
}
